import { CONTAINER, TYPES } from '../../../config';

import { Dictionary, GetterClass, MessagesState } from '../../../models';

export class LocaleGetter implements GetterClass {

  public static execute(state: MessagesState): string {
    const messages = CONTAINER.get<Dictionary<Dictionary>>(TYPES.Messages);
    if (state.locale in messages) {
      return state.locale;
    }
    const trimmedLocale = state.locale.slice(0, 2);
    if (trimmedLocale in messages) {
      return trimmedLocale;
    }
    return state.fallbackLocale;
  }

}
